'use strict';

var REACT_BASE_PATH =
  window.location.port === '3001'
    ? 'http://localhost:3000'
    : '/v2/web/index.html';

function reactUrl(path) {
  return REACT_BASE_PATH + '#' + path;
}

var ReactNavigationService = /*@ngInject*/ function ($window, $location, $stateParams) {
  this.getReactPath = function (target, params) {
    params = params || {};

    switch (target) {
      case 'search':
        var term = params.q || '*';
        return '/search?term=' + encodeURIComponent(term) + '&type=All';
      case 'queue.qa':
        var qaTab = params.tab || 'unassigned';
        return '/queues/qa?tab=' + qaTab;
      case 'queue.post-prod':
        return '/queues/post-prod?tab=unassigned';
      case 'detail':
        if (params.jobId) {
          return '/job/' + params.jobId;
        }
        return '/product/' + params.productIdentifier;
      case 'admin':
        if (
          params.section === 'bulk-job-update' ||
          params.section === 'record-links'
        ) {
          return '/admin/' + params.section;
        }
        return '/';
      default:
        return '/';
    }
  };

  this.goToDestination = function (target, params) {
    $window.location.assign(reactUrl(this.getReactPath(target, params)));
  };

  this.goToSearch = function (query) {
    this.goToDestination('search', { q: query });
  };

  this.goToJobDetail = function (jobId) {
    this.goToDestination('detail', { jobId: jobId });
  };

  this.goToProductDetail = function (productId) {
    this.goToDestination('detail', { productIdentifier: productId });
  };

  this.goToQAQueue = function (tab) {
    var queueTab =
      tab || $location.search().tab || $stateParams.tab || 'unassigned';
    this.goToDestination('queue.qa', { tab: queueTab });
  };

  this.goToPostProdQueue = function () {
    this.goToDestination('queue.post-prod', {});
  };

  this.goToAdmin = function (section) {
    this.goToDestination('admin', { section: section });
  };

  this.goToHome = function () {
    this.goToDestination('home', {});
  };

  this.buildUrl = reactUrl;
};

module.exports = ReactNavigationService;
